import request from '@/utils/httpRequest'

export default class auditService {
    materFlowConfirm(data) {
        return request({
            url: '/mater/flowprocess/materFlowConfirm',
            method: 'post',
            data: data,
            class:'mater'
        })
    }
}
